import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { Flex } from './flex';
import { Type } from './text';

export function FormLabel({
  children,
  label,
  extra,
  isOptional,
  className,
  linkText,
  link,
}) {
  return (
    <Flex direction="col" gap="none" items="start" className={cn('w-full', className)}>
      <Flex items="center" gap="sm" className="w-full">
        <Flex items="center" gap="xs">
          <Type size="sm" weight="medium">
            {label}
          </Type>
          {isOptional && (
            <Type size="xs" textColor="secondary">
              (Optional)
            </Type>
          )}
        </Flex>
        {link && (
          link.startsWith('http') ? (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="decoration-primary/20 py-0.5 text-sm font-medium text-violet-500 underline underline-offset-4 hover:opacity-90"
            >
              {linkText}
            </a>
          ) : (
            <Link
              to={link}
              target="_blank"
              rel="noopener noreferrer"
              className="decoration-primary/20 py-0.5 text-sm font-medium text-violet-500 underline underline-offset-4 hover:opacity-90"
            >
              {linkText}
            </Link>
          )
        )}
        {extra && extra()}
      </Flex>
      {children && (
        <Type size="xs" textColor="secondary">
          {children}
        </Type>
      )}
    </Flex>
  );
}
